module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAoCAYAAACb3CikAAAAAXNSR0IArs4c6QAAAQJJREFUWEftmE0KwjAQhd9QwWPoQg+iIHgGd2IX9a/iScT40y4i7jyDIOhBdKHHECwj2YgEMZRq6WKyTeA9vrwMmSEV6QWAdgKvNe13r8hxzaJt1UNyALAnFekHAI8Iw3Hgr3P0gUWsB8xYAUiMETbiTBROgp6hk9uax5sxMSsjKEYMBSFihy8TkeVSV5ISOmAuf0w10d17YDca+TdX6jMZUbE+gtH4KkI4hYHf/K+RSJ8B1Bwil7Dv18XIGwEhYsdBiAgRqSOvDCiprNZ7ECJ2gRAiQsT1q5KMSEacGSlKO1GYBstFLM1+pk4vjZDrrBj56TTAhTvNvn01hRnmFWK8+QTtwDwJuvntpgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nor.png
// module id = H4kZ
// module chunks = 0